import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/SiteManagement/Form/DrawingList/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import Swal from 'sweetalert2';
import { v3_fetchNewBuildingDrawingListFields, v3_fetchNewBuildingSiteQueryReportIndexFields, v3_submitNewBuildingDrawingList } from '../../../actions/v3/siteManagement';
import { v2_yards } from '../../../actions/v2/masterData';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)
    const defaultRow = {
        date_issued: { name: 'date_issued', value: '', error: '', isRequired: true },
        drawing_number: { name: 'drawing_number', value: '', error: '', isRequired: true },
        revision_number: { name: 'revision_number', value: '', error: '', isRequired: true },
        subject: { name: 'subject', value: '', error: '', isRequired: true },
        remark: { name: 'remark', value: '', error: '', isRequired: true },

    };

    const [state, setState] = useState([defaultRow]);
    const handleChange = (field, value, index = 0) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };
            return updatedState;
        });
    };

    const addRow = () => {
        setState(prev => [...prev, JSON.parse(JSON.stringify(defaultRow))]);
    };

    const removeRow = (indexToRemove) => {
        setState(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        // date: { value: '', error: '' },
        finalSubmit: { value: false },
        owner: { value: '' },
        yard: { value: '', options: [] },


    });

    const [showLoader, setShowLoader] = useState(false);

    // Load yards
    useEffect(() => {
        v2_yards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when yard changes
    useEffect(() => {
        if (commonDetails.yard.value) {
            v2_ships(null, null, commonDetails.yard.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.yard.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingDrawingListFields(
                params.ID
            )
                .then((res) => {
                    if (res.status) {
                        const { commonDetails, records = [] } = res.result;

                        // set common details if editing
                        if (params.ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                yard: { ...prev.yard, value: commonDetails?.YARD_ID || '' },
                                ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                                finalSubmit: { value: Boolean(commonDetails?.FINAL_SUBMITTED) },
                            }));
                        }

                        // convert flat records to form model
                        const mappedItems = records.map((item) => {
                            return {
                                entryId: item.ID,
                                date_issued: {
                                    ...defaultRow.date_issued,
                                    value: item.DATE_ISSUED || '',
                                },
                                drawing_number: {
                                    ...defaultRow.drawing_number,
                                    value: item.DRAWING_NUMBER || '',
                                },
                                subject: {
                                    ...defaultRow.subject,
                                    value: item.SUBJECT || '',
                                },
                                revision_number: {
                                    ...defaultRow.revision_number,
                                    value: item.REVISION_NUMBER || '',
                                }, remark: {
                                    ...defaultRow.remark,
                                    value: item.REMARK || '',
                                }

                            };
                        });

                        // set state (renamed from state to items if needed)
                        setState(mappedItems);
                    } else {
                        toast.error(res.error);
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }

    }, []);

    const onSubmit = async () => {
        // 1. Validation
        const errors = [];
        if (!commonDetails.yard.value) errors.push('Select a yard.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');

        // Validate each row
        state.forEach((row, index) => {
            Object.entries(row).forEach(([key, field]) => {
                if (key === 'entryId') return; // Skip entryId

                const isRequired = field.isRequired || commonDetails.finalSubmit.value; // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`Row ${index + 1}: ${key.replace(/_/g, ' ')} is required.`);
                }
            });
        });


        if (errors.length > 0) {
            toast.error(errors.join('\n'));
            return;
        }
        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }


        // 2. Build checklistItems payload
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                formattedRow[key.toUpperCase()] = row[key].value;
            });
            if (row['entryId']) {
                formattedRow.ID = row['entryId']
            }
            return formattedRow;
        });

        // 3. Build full payload
        const payload = {
            commonDetails: {
                yard: commonDetails.yard.value,
                ship: commonDetails.ship.value,
                // date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,

            },
            checklistItems,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildingDrawingList(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedDrawingList.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const selected = commonDetails.ship.options.find(
            (i) => i.ID == commonDetails.ship.value
        );

        if (selected) {
            setCommonDetails((prev) => ({
                ...prev,
                owner: {
                    ...prev.owner,
                    value: selected.OWNER_NAME || ''
                },
            }));
        }
    }, [commonDetails.ship.value, commonDetails.ship.options]);



    return (
        <Layout title="Drawing List">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Drawing List
                                            </h4>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 pl10">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.yard.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    yard: { ...prev.yard, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Yard</option>
                                                            {commonDetails.yard.options.map((item) => {
                                                                return (<option value={item.ID}> {item.YARD_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>

                                                    <td className="hd-s2 pl10">
                                                        <p>Hull</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={data ? true : false}
                                                            value={commonDetails.ship.value}
                                                            onChange={(e) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    ship: { ...prev.ship, value: e.target.value }
                                                                }));
                                                            }}


                                                        >

                                                            <option value={''}>Select Hull</option>
                                                            {commonDetails.ship.options.map((item) => {
                                                                return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Owner</p>
                                                    </td>
                                                    <td className="">

                                                        <input
                                                            className="form-control"
                                                            type='text'
                                                            value={commonDetails.owner.value}
                                                            placeholder='Autofill'
                                                            disabled
                                                        />

                                                    </td>
                                                    {/* <td className="hd-s2 pl10">
                                                        <p>Date</p>
                                                    </td>
                                                    <td className="">
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={commonDetails.date.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    date: { ...prev.date, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td> */}

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus